import React, { memo, Suspense } from 'react';
import { Layout } from 'antd';
import { IRoute } from 'data';
import ConfigContent from './ConfigContent';

const { Content } = Layout;

interface AppContentProps {
  filteredRoutes: IRoute[];
}

const AppContent: React.FC<AppContentProps> = ({ filteredRoutes }) => {
  return (
    <Content className="app-content">
      <Suspense fallback={null}>
        <ConfigContent filteredRoutes={filteredRoutes} />
      </Suspense>
    </Content>
  );
};

export default memo(AppContent);
